import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/Section/layouts/Wealth/+types/WealthPage";
import { WealthPageContext } from "@routes/Section/layouts/Wealth/utils/types";
import { fetchWealthPageData } from "@routes/Section/layouts/Wealth/WealthPage.server";
import WealthPageContent from "@routes/Section/layouts/Wealth/WealthPageContent";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /wealth route. */
const WealthPage = (): React.ReactElement => {
  const context = useLoaderData<WealthPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <WealthPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default WealthPage;

export const loader = async () => await fetchWealthPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as WealthPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};
